import { Component } from "@angular/core";

@Component({
  templateUrl: "./video-too-large.component.html",
  styleUrls: ["./video-too-large.component.scss"],
})
export class VideoTooLargeComponent {
  constructor() {}
}
